/**
 * Scroll to the first element that matches the CSS selector.
 */
export const scrollToElement = (query: string) => {
  const firstQueriedElement = document.querySelectorAll(query)[0]

  if (firstQueriedElement)
    firstQueriedElement.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    })
}
